import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom'
import JobProfileSummary from "./JobProfileSummary";
import Component from "../../../components/Component";
import LoadingSpinner from "../../../components/LoadingSpinner";
import {AuthContext} from "../../../providers/AuthProvider";

class JobProfileSummaryModal extends Component {
    //contextType of the component is AuthContext. i.e this.context.auth = TB auth user
    static contextType = AuthContext;

    constructor(props) {
        super(props);

        this.state = {
            isLoading: true
        }
    }

    async componentDidMount() {
        super.componentDidMount();


        await TB.wait(350);
        return this.promisedState({isLoading:false})
    }

    render() {

        let {
            isLoading
        } = this.state;

        return (
            <div className="job-match-score-panel">
                <div className="job-match-header">
                    Your Proposal has been Updated. Now is a great time to update your profile!
                </div>

                    {isLoading && (
                        <div className="job-match-loading">
                            <LoadingSpinner size={'lg'}/>
                        </div>
                    )}

                    {!isLoading && (
                        <React.Fragment>
                            <JobProfileSummary {...this.props}/>

                            <div className="job-match-footer m-0 flex-nowrap justify-between gap-3 md:justify-end">
                                <Link
                                    to="/talent/application"
                                    onClick={() => this.props.onRequestClose(true)}
                                    className="btn btn-primary"
                                >
                                    Edit Profile
                                </Link>
                                <button disabled={this.props.disabled} className="btn btn-outline-dark" onClick={() => this.props.onRequestClose()}>
                                    Close
                                </button>
                            </div>
                        </React.Fragment>
                    )}
            </div>

        )
    }
}

JobProfileSummaryModal.propsTypes = {
    onRequestClose: PropTypes.func,
}

export default JobProfileSummaryModal;